<template>
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom" :width="620" @close="closeDialog">
    <div slot="title">
      {{$t('core.editor_history')}}
      <qc-bubble :append-to-body="false" placement="right">
        <qc-icon type="plaint"></qc-icon>
        <template slot="popup">{{$t('core.keep_historical_record_param',{num: 100})}}</template>
      </qc-bubble>
    </div>

    <div class="history-content">
      <div class="tc-action-grid">
        <div class="justify-grid">
          <div class="col">
            <qc-button @click="clearCache">{{$t('core.clear_editor_history')}}</qc-button>
          </div>
        </div>
      </div>
      <qc-table min-height="0" max-height="400px" :list="list" :empty-tips="$t('core.list_empty')" :loading="loading"
        :page-size="100" :default-page-size="100">
        <qc-table-column :label="$t('core.file_name')" field="name"></qc-table-column>
        <qc-table-column :label="$t('core.ctime')" field="ctime" width="150px">
          <template slot-scope="{ item }">
            <div>
              {{item.ctime}}
            </div>
          </template>
        </qc-table-column>
        <qc-table-column :label="$t('core.action')" width="100px">
          <template slot-scope="{ item, rowIndex }">
            <div class="tc-g cos-table-operate">
              <div class="tc-g-u-1-3 ml-10">
                <div class="cos-icon--16 download" :title="$t('core.download')" @click="onDownload(item)">
                </div>
              </div>
              <div class="tc-g-u-1-3 ml-5">
                <div class="cos-icon--16 delete" :title="$t('core.delete')" @click="onDelete(item,rowIndex)"></div>
              </div>
            </div>
          </template>
        </qc-table-column>
      </qc-table>
    </div>

  </qc-dialog>
</template>

<script>
import { getInnerProps, tips } from '@/scripts/tools/utils';
import dialog from '@/scripts/tools/dialog';
import editorTools from '@/scripts/helper/editor/tools';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      loading: false,
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
  },
  watch: {
    show(val) {
      if (val) {
        this.initData();
      }
    },
  },
  methods: {
    async initData() {
      this.loading = true;
      this.list = await editorTools.handleHistoryFiles();
      this.loading = false;
    },
    async onDownload(item) {
      try {
        const file = await editorTools.getHistoryFileByTime(item.timestamp);
        const url = window.URL.createObjectURL(new Blob([file.content], { type: 'arraybuffer' }));
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', file.name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        tips.error(this.$t('error.local_file_not_exist'));
      }
    },
    onDelete(item, index) {
      dialog.confirm(
        {
          title: window.lang.t('core.default_title'),
          message: this.$t('core.confirm_delete_record', {
            title: window.lang.t('core.default_title'),
            name: item.name,
          }),
        },
        confirm => {
          if (!confirm) return;
          editorTools.deleteHistoryByTime(item.timestamp).then(() => {
            this.list.splice(index, 1);
          });
        },
      );
    },
    clearCache() {
      dialog.confirm(
        {
          title: window.lang.t('core.default_title'),
          message: this.$t('core.confirm_clear_edit_history'),
        },
        confirm => {
          if (!confirm) return;
          tips.loading(this.$t('core.deleting'));
          editorTools.clearHistory().then(() => {
            tips.closeTips();
            this.initData();
          }).catch(() => {
            tips.closeTips();
            tips.error(this.$t('error.part_files_delete_failed'));
            this.initData();
          });
        },
      );
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>
